import apiClient from "services/apiClient";

const saveBlobAsFile = (blob, fileName) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName || "download";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const resolveAudioDownloadName = (message, url) => {
  const storedName = String(message?.file_name || "").trim();
  if (storedName) {
    return storedName;
  }

  const mimeType = String(message?.mime_type || "").toLowerCase();
  const mimeExtensionMap = {
    "audio/ogg": "ogg",
    "audio/mpeg": "mp3",
    "audio/mp4": "m4a",
    "audio/aac": "aac",
    "audio/wav": "wav",
    "audio/x-wav": "wav",
  };

  for (const [mime, extension] of Object.entries(mimeExtensionMap)) {
    if (mimeType.includes(mime)) {
      return `audio.${extension}`;
    }
  }

  const fromUrl = String(url || "")
    .split(".")
    .pop()
    ?.split(/[?#]/)[0]
    ?.toLowerCase();

  if (fromUrl && ["ogg", "mp3", "m4a", "aac", "wav", "opus"].includes(fromUrl)) {
    return `audio.${fromUrl}`;
  }

  return "audio.ogg";
};

export const downloadReportMediaFile = async ({
  api,
  authToken,
  reportId,
  fileName,
  fallbackUrl,
}) => {
  if (reportId) {
    const response = await apiClient.get(`${api}reports-media/download/${reportId}`, {
      responseType: "blob",
      headers: authToken
        ? {
            Authorization: `Bearer ${authToken}`,
          }
        : {},
    });

    const blob = response.data;
    const headerName = response.headers?.["content-disposition"];
    const matchedName = headerName?.match(/filename="?([^"]+)"?/i)?.[1];
    saveBlobAsFile(blob, fileName || matchedName || "download");

    return;
  }

  if (!fallbackUrl) {
    throw new Error("No download source available");
  }

  const response = await fetch(fallbackUrl);
  if (!response.ok) {
    throw new Error("Failed to download file");
  }

  const blob = await response.blob();
  saveBlobAsFile(blob, fileName || "download");
};
